<script>
import axios from 'axios'
export default {
  props: ['kegiatan_id', 'kegiatan_type', 'jenjang'],
  methods: {
    async resetStatusKelulusan() {
      await axios.post('/'+this.jenjang+'/reset-status-kelulusan', {
        kegiatan_id: this.kegiatan_id,
        kegiatan_type: this.kegiatan_type,
      })
      window.$.notify({
        // options
        message: 'Status kelulusan telah direset. Silakan muat ulang halaman ini untuk melihat perubahan.'
      },{
        // settings
        type: 'success',
        delay: 1250,
        placement: {
          from: "top",
          align: "center"
        },
      });
    }
  },
}
</script>
<template>
  <button @click="resetStatusKelulusan" type="button" class="btn btn-primary">Reset Status Kelulusan</button>
</template>